"use client";

import axios from "axios";
import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { ipAddressAtom } from "./_store";
import useSWR from "swr";

export default function IPAddressContext() {
  const setIpAddress = useSetAtom(ipAddressAtom);

  const { data: ipAddress } = useSWR<string>("https://ipv4.icanhazip.com/", async function (url: string) {
    const res = await axios.get(url, {
      headers: {
        Accept: ["application/json", "text/plain", "*/*"],
      },
    });
    console.log("Client's Ipv4 address: ",res.data);
    return res.data;
  });
  useEffect(() => {
    if (ipAddress) setIpAddress(ipAddress.trim());
  }, [ipAddress]);
  return <></>;
}
